import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import classNames from 'classnames';
import compose from 'lodash/fp/compose';
import { AddFile, MenuEllipsis } from 'jbc-front/components/icons';
import { withTranslation, useTranslation } from 'react-i18next';

import { getSelectOptions } from 'src/reducers/selectOptions';
import { TARGET_EMPLOYEE_BONUS } from 'src/constants/EndpointUrls';
import { fetchEmployeeBonus, REDUCER_NAME } from 'src/reducers/employees/employeeBonus';
import { getIsLoading } from 'src/reducers/common/listReducer';
import { clearErrors as clearModalErrors } from 'src/reducers/clients/clientBonus';
import Confirmed from 'src/components/Confirmed';
import SearchFormPaginator from 'src/components/SearchFormPaginator';
import DetailSearchForm from 'src/components/DetailSearchForm';
import BonusSelectBox from 'src/components/BonusSelectBox';
import IconActionButton from 'src/components/IconActionButton';
import ExtraActionsSection from 'src/features/EmployeeBonus/components/ExtraActionsSection';
import SearchDetector from 'src/components/SearchDetector';
import ConfirmBonus from 'src/features/EmployeeBonus/containers/ConfirmBonusContainer';
import {
  takeBonusesSearchQueries,
  takeBonusConfirmedStateFromSearchForm,
  takeBonusesSearchQueriesFromLocation,
  takeBonusesResetFormQueries,
  takeBonusesQueriedUrl,
  bonusesSearchFormSelector,
  fetchBonusOptions,
  FORM_NAME_BONUSES_SEARCH,
  isLoading,
  ITEM_NAME_FETCH_BONUS_OPTIONS
} from 'src/reducers/searchForm';
import LoadingView from 'src/components/LoadingView';
import { fetchConfirmJobStatus, getJob } from 'src/reducers/JobStatus';
import BonusFormModal from 'src/components/BonusFormModal';
import EmployeeBonusTable from './components/EmployeeBonusTable';
import DeleteClientBonusModal from './components/DeleteClientBonusModal';
import BonusTargetDateRange from './components/BonusTargetDateRange';
import AllJobStatusContainer from '../../components/JobStatus/AllJobStatusContainer';
import styles from './EmployeeBonusList.scss';

const EmployeeBonusNoData = ({ handleCreateBonus } = this.props) => {
  const { t, i18n } = useTranslation();
  return (
    <div className={styles.nolist}>
      <div className={styles.notext}>
        <p>
          {t('features.EmployeeBonus.EmployeeBonusList.no_registered_bonus_data')}<br />{t('features.EmployeeBonus.EmployeeBonusList.click_the_create_new_bonus_button_below_to_create_new_bonus_data')}
        </p>
      </div>
      <div className={styles.menu}>
        <div onClick={handleCreateBonus} className={styles.createButton} role="presentation">
          <AddFile size={28} />{t('features.EmployeeBonus.EmployeeBonusList.create_new_bonus')}
        </div>
      </div>
    </div>
  );
};

class EmployeeBonusList extends React.Component {
  constructor(props) {
    super(props);

    this.lockAllTableRows = this.lockAllTableRows.bind(this);
    this.unlockAllTableRows = this.unlockAllTableRows.bind(this);
    this.onClickCheckboxRow = this.onClickCheckboxRow.bind(this);
    this.onClickCreateBonus = this.onClickCreateBonus.bind(this);
    this.onClickEditBonus = this.onClickEditBonus.bind(this);
    this.onClickDeleteBonus = this.onClickDeleteBonus.bind(this);

    this.state = {
      selectingEmployeeBonus: [],
      isNewBonusModalOpen: false,
      isEditBonusModalOpen: false,
      isDeleteBonusModalOpen: false
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchBonusOptions());
    dispatch(this.props.fetchConfirmClientBonusJobStatus);
  }

  onDeleteSelectingBonusSuccess(onSuccessCallback) {
    onSuccessCallback();
    this.setState({
      ...this.state,
      selectingEmployeeBonus: []
    });
  }

  //モーダル作成
  onClickCheckboxRow(item) {
    let selectingEmployeeBonus = [];
    if (this.state.selectingEmployeeBonus.find(id => id === item.id)) {
      selectingEmployeeBonus = this.state.selectingEmployeeBonus.filter(id => id !== item.id);
    } else {
      selectingEmployeeBonus = [...this.state.selectingEmployeeBonus, item.id];
    }

    this.setState({
      ...this.state,
      selectingEmployeeBonus
    });
  }

  lockAllTableRows() {
    this.setState({
      ...this.state
    });
  }

  unlockAllTableRows() {
    this.setState({
      ...this.state
    });
  }

  onClickCreateBonus() {
    this.setState({ isNewBonusModalOpen: true });
  }

  onClickEditBonus() {
    this.setState({ isEditBonusModalOpen: true });
  }

  onClickDeleteBonus() {
    this.setState({ isDeleteBonusModalOpen: true });
  }

  taskStyle = (job, cssStyles) => {
    switch (job.status) {
      case 'failed':
        return cssStyles.tasksFailed;
      case 'in_progress':
      case 'waiting':
        return cssStyles.tasksInprogress;
      default:
        return cssStyles.tasksSuccess;
    }
  };

  statusText = job => {
    switch (job.status) {
      case 'failed':
        return this.props.t('features.EmployeeBonus.EmployeeBonusList.bonus_list', { framework: "react-i18next" });
      case 'in_progress':
      case 'waiting':
        return this.props.t('features.EmployeeBonus.EmployeeBonusList.bonus_in_confirming_process', { framework: "react-i18next" });
      default:
        return this.props.t('features.EmployeeBonus.EmployeeBonusList.bonus_confirmed', { framework: "react-i18next" });
    }
  };

  render() {
    const {
      initialValues: formValues,
      clientBonusId,
      location,
      isConfirmed,
      resetValues,
      editTargetUrl,
      dispatch,
      isBonusBlank,
      isOptionsLoading,
      isListLoading,
      confirmClientBonusJob
    } = this.props;

    return (
      <div>
        <SearchDetector
          location={location}
          clientBonusId={clientBonusId}
          willReceivePropsDetectingJudger={(prevProps, nextProps) =>
            nextProps.clientBonusId !== undefined &&
            (prevProps.clientBonusId === undefined || nextProps.location !== prevProps.location)
          }
          onDetect={() => {
            dispatch(fetchEmployeeBonus(takeBonusesSearchQueries(formValues)));
          }}
        />
        {isBonusBlank ? (
          <LoadingView isLoading={isOptionsLoading}>
            <EmployeeBonusNoData handleCreateBonus={this.onClickCreateBonus} />
          </LoadingView>
        ) : (
          <div>
            <div className="l-main-title-wrap">
              <h1 className="m-title-main">{this.props.t('features.EmployeeBonus.EmployeeBonusList.bonus_list', { framework: "react-i18next"})}</h1>
            </div>
            {!_.isEmpty(confirmClientBonusJob) &&
              !_.isUndefined(confirmClientBonusJob.name) && (
                <AllJobStatusContainer
                  task={confirmClientBonusJob}
                  taskStyle={this.taskStyle}
                  statusText={this.statusText}
                />
              )}
            <div className="l-wrap-xl">
              <div className={styles.select}>
                {isConfirmed && (
                  <div className={styles.confirmed}>
                    <Confirmed />
                  </div>
                )}
                <div className={styles.menu}>
                  <div className={styles.menuItem}>
                    <div onClick={this.onClickCreateBonus} className={styles.createButton} role="presentation">
                      <AddFile size={28} />{this.props.t('features.EmployeeBonus.EmployeeBonusList.create_new_bonus', { framework: "react-i18next" })}
                    </div>
                  </div>
                  <div className={styles.menuItem}>
                    <BonusSelectBox />
                  </div>
                  <div className={styles.menuItem}>
                    <IconActionButton
                      icon={<MenuEllipsis size={24} />}
                      options={() => (
                        <ul className={styles.editlist}>
                          <li>
                            <a
                              onClick={() => {
                                dispatch(clearModalErrors());
                                this.onClickEditBonus();
                              }}
                              role="presentation"
                              className={isConfirmed ? styles.disabled : ''}
                            >
                              {this.props.t('features.EmployeeBonus.EmployeeBonusList.edit_bonus_data', { framework: "react-i18next" })}
                            </a>
                          </li>
                          <li>
                            <a href={editTargetUrl} className={isConfirmed ? styles.disabled : ''}>
                              {this.props.t('features.EmployeeBonus.EmployeeBonusList.edit_target_person', { framework: "react-i18next" })}
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={this.onClickDeleteBonus}
                              role="presentation"
                              className={isConfirmed ? styles.disabled : ''}
                            >
                              {this.props.t('features.EmployeeBonus.EmployeeBonusList.delete_bonus_information', { framework: "react-i18next" })}
                            </a>
                          </li>
                        </ul>
                      )}
                    />
                  </div>
                </div>
                <ConfirmBonus unlockAllTableRows={this.unlockAllTableRows} />
              </div>
              <BonusTargetDateRange />
            </div>
            <div className="l-wrap-xl">
              <DetailSearchForm
                menuRender={() => <ExtraActionsSection clientBonusId={clientBonusId} isConfirmed={isConfirmed} />}
                containsOtherSearch={false}
                formName={FORM_NAME_BONUSES_SEARCH}
                resetValues={resetValues}
              />
            </div>
            <LoadingView isLoading={isListLoading}>
              <div>
                <div className={classNames('l-wrap-xl', styles.list)}>
                  <EmployeeBonusTable />
                  <SearchFormPaginator formName={FORM_NAME_BONUSES_SEARCH} reducerName={REDUCER_NAME} />
                </div>
              </div>
            </LoadingView>
            {this.state.isEditBonusModalOpen && (
              <BonusFormModal
                isEditForm
                isOpen={this.state.isEditBonusModalOpen}
                hideModal={() => {
                  this.setState({ isEditBonusModalOpen: false });
                }}
                clientBonusId={clientBonusId}
              />
            )}
            {this.state.isDeleteBonusModalOpen && (
              <DeleteClientBonusModal
                isOpen={this.state.isDeleteBonusModalOpen}
                hideModal={() => {
                  this.setState({ isDeleteBonusModalOpen: false });
                }}
              />
            )}
          </div>
        )}
        {this.state.isNewBonusModalOpen && (
          <BonusFormModal
            isEditForm={false}
            isOpen={this.state.isNewBonusModalOpen}
            hideModal={() => {
              this.setState({ isNewBonusModalOpen: false });
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  initialValues: {
    ...takeBonusesSearchQueriesFromLocation(state.router.location, true),
    ...getFormValues(FORM_NAME_BONUSES_SEARCH)(state)
  },
  clientBonusId: bonusesSearchFormSelector(state, 'clientBonusId'),
  resetValues: takeBonusesResetFormQueries(state, true),
  location: state.router.location,
  isConfirmed: takeBonusConfirmedStateFromSearchForm(state),
  isBonusBlank: _.isEmpty(getSelectOptions(state, 'bonuses')),
  editTargetUrl: takeBonusesQueriedUrl(TARGET_EMPLOYEE_BONUS, getFormValues(FORM_NAME_BONUSES_SEARCH)(state)),
  isOptionsLoading: isLoading(ITEM_NAME_FETCH_BONUS_OPTIONS, state),
  isListLoading: getIsLoading(REDUCER_NAME, state),
  confirmClientBonusJob: _.get(getJob(state), 'confirmClientBonusJob')
});

const mapDispatchToProps = dispatch => ({
  fetchConfirmClientBonusJobStatus: () => {
    dispatch(fetchConfirmJobStatus());
  }
});

export default withTranslation('translation') (compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: FORM_NAME_BONUSES_SEARCH,
    enableReinitialize: true
  })
)(EmployeeBonusList));
